export enum HistoryEntityNamesEnum {
  CASE = 'Case',
  PROBLEM_RECORD = 'ProblemRecord',
  CASE_RECORD = 'CaseRecord'
}

export enum HistoryTabsEnum {
  OVERVIEW = 'overview',
  COLLABORATION = 'collaboration',
  SUMMARY = 'summary'
}
